import { render } from "./NewGoalKRPanel.vue?vue&type=template&id=23c582aa"
import script from "./NewGoalKRPanel.vue?vue&type=script&lang=js"
export * from "./NewGoalKRPanel.vue?vue&type=script&lang=js"
script.render = render

export default script